import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import WhyChoose from './components/WhyChoose';
import ArticleCard from './components/ArticleCard';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategoryDropdown />
      <CategoryGrid />
      <WhatIsSection />
      <WhyChoose />
      <ArticleCard />
      <Footer />
    </main>
  );
}